<template>
  <q-icon :name="name" :size="size"/>
</template>

<script>
export default {
  name: 'RIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: [Number, String],
  },
};
</script>
